import React, { useEffect } from "react";
import styles from "./shift-records-details-info.module.scss";
import {
  Button,
  Checkbox,
  DatePicker,
  DateTimePickerPopup,
  Dropdown,
  Field,
  Image,
  Loader,
  Pill,
  Text,
  TextField,
} from "components/commons";
import LabelAndValueRow from "components/commons/label-and-value/label-and-value-row";
import { locale } from "localization/en";
import { dateFormat, dateTimeFormatSlash, timeFormat } from "utils";
import { EmployeePosition, FormMode, ShiftStatus } from "enums";
import { TrashcanIcon } from "images";
import { prettifyEmployeePosition } from "utils/pretty.utils";
import Validation from "utils/validation.utils";
import grid from "styles/grid.module.scss";
import AddIcon from "@material-ui/icons/Add";
import {
  employeeAnchorId,
  fieldAnchorId,
  isFormFieldIncomplete,
} from "../shift-records-details-completion";

const ShiftRecordsDetailsInfoModule = ({
  loadingShift,
  station,
  shift,
  pageMode,
  employees,
  setEmployees,
  form,
}) => {
  const { fields, modifyField } = form;

  console.log({
    employees,
  });
  const addRow = () => {
    setEmployees((emp) => {
      return [
        ...emp,
        {
          shiftEmployeeId: null,
          name: "",
          agency: "",
          label: "",
          nameCheck: true,
          agencyCheck: true,
          labelCheck: true,
          timeInAt: null,
          timeOutAt: null,
          isStraightDuty: false,
          timeInAtCheck: true,
          timeOutAtCheck: true,
        },
      ];
    });
  };

  const onRemove = (i) => {
    const newForm = [...employees];
    newForm.splice(i, 1);
    setEmployees(newForm);
  };

  const namePattern = /^[a-zA-Z\s'.-]+$/;

  const onChangeName = (value, i) => {
    const newForm = [...employees];
    newForm[i]["name"] = value;
    newForm[i].nameCheck =
      !value || value.length < 2 || value.length > 100 || !namePattern.test(value);
    setEmployees(newForm);
  };

  const onChangeAgency = (value, i) => {
    const newForm = [...employees];
    let inValid = true;
    newForm[i]["agency"] = value;
    if (value.length > 0) {
      inValid = false;
    }
    newForm[i].agencyCheck = inValid;

    setEmployees(newForm);
  };

  const onChangeLabel = (value, i) => {
    const newForm = [...employees];
    let inValid = true;
    newForm[i]["label"] = value;
    if (value.length > 0) {
      inValid = false;
    }
    newForm[i].labelCheck = inValid;

    setEmployees(newForm);
  };

  const onChangeTimeIn = (value, i) => {
    const newForm = [...employees];
    newForm[i]["timeInAt"] = value;
    newForm[i].timeInAtCheck = !value;
    const existingTimeOut = newForm[i].timeOutAt ? new Date(newForm[i].timeOutAt) : null;
    if (value && existingTimeOut && new Date(value) >= existingTimeOut) {
      newForm[i].timeOutAt = null;
      newForm[i].timeOutAtCheck = true;
    }
    setEmployees(newForm);
  };

  const onChangeTimeOut = (value, i) => {
    const newForm = [...employees];
    newForm[i]["timeOutAt"] = value;
    const timeIn = newForm[i].timeInAt ? new Date(newForm[i].timeInAt) : null;
    const isInvalid = !value || (timeIn && new Date(value) <= timeIn);
    newForm[i].timeOutAtCheck = isInvalid;
    setEmployees(newForm);
  };

  const onChangeStraightDuty = (value, i) => {
    const newForm = [...employees];
    newForm[i]["isStraightDuty"] = value;
    setEmployees(newForm);
  };

  const employeeNameMessage = (item) =>
    !item.nameCheck
      ? ""
      : !item.name
        ? locale.pleaseEnterEmployeeOnDuty
        : locale.pleaseEnterAValidEmployeeName;

  const employeeTimeOutMessage = (item) =>
    !item.timeOutAtCheck
      ? ""
      : !item.timeOutAt
        ? locale.pleaseSelectDateAndTimeOut
        : locale.dateAndTimeOutMustBeAfterDateAndTimeIn;

  useEffect(() => {
    if (pageMode === FormMode.Edit) {
      if (employees.length > 0 && employees[0].agency === "Employee") {
        onChangeAgency("", 0); //overwrite employee placeholder
      }

      if (employees.length === 0) {
        addRow(); // add default row if cashier is empty
      }
    }
  });

  return (
    <>
      <Loader open={loadingShift} />
      {shift && !loadingShift && (
        <div>
          <div className={styles.container}>
            <div>
              <div>
                <Text className={styles.header}>{station?.name}</Text>
              </div>
              <div style={{ width: "100%" }}>
                {pageMode === FormMode.Edit ? (
                  <div
                    id={fieldAnchorId("shiftDate")}
                    data-incomplete={isFormFieldIncomplete(fields?.shiftDate)}
                  >
                    <Field className={styles.fields} {...fields?.shiftDate} horizontal>
                      <DatePicker
                        {...fields?.shiftDate}
                        allowPastDates
                        disableEndDate={new Date()}
                        placeholder={"DD MM YYYY"}
                        onChange={(name, value) => modifyField(name, value)}
                      />
                    </Field>
                  </div>
                ) : (
                  <LabelAndValueRow
                    label={locale.shiftDate}
                    desc={dateFormat(shift?.shift.shiftDate || shift?.shift.startShift)}
                  />
                )}
                <LabelAndValueRow
                  label={locale.shiftDuration}
                  desc={`${dateFormat(shift?.shift.startShift)} ${timeFormat(
                    shift?.shift.startShift,
                  )} - ${dateFormat(shift?.shift.endShift)} ${timeFormat(shift?.shift.endShift)}`}
                />
                {pageMode === FormMode.Edit ? (
                  <div
                    id={fieldAnchorId("shiftNumber")}
                    data-incomplete={isFormFieldIncomplete(fields?.shiftNumber)}
                  >
                    <Field className={styles.fields} {...fields?.shiftNumber} horizontal>
                      <Dropdown
                        {...fields?.shiftNumber}
                        options={[
                          { label: "1", value: "1" },
                          { label: "2", value: "2" },
                          { label: "3", value: "3" },
                        ]}
                        onChange={(value) => modifyField(fields?.shiftNumber?.name, { value })}
                      />
                    </Field>
                  </div>
                ) : (
                  <LabelAndValueRow
                    label={locale.shiftNumber}
                    desc={
                      shift?.shift.status === ShiftStatus.Started
                        ? locale.currentShift
                        : shift?.shift.shiftNumber || "-"
                    }
                  />
                )}
              </div>
              <div style={{ marginBottom: "1em" }}>
                <Text className={styles.header}>{locale.shiftAttendance}</Text>
              </div>
              {pageMode === FormMode.Edit ? (
                <div>
                  {employees
                    .map((item, originalIndex) => ({ item, originalIndex }))
                    .filter(({ item }) => item.name?.toLowerCase() !== "stocq variance")
                    .map(({ item, originalIndex }, displayIndex) => (
                      <div key={originalIndex} className={styles.attendanceCard}>
                        <div className={styles.attendanceRow}>
                          <div
                            className={styles.attendanceField}
                            id={employeeAnchorId(originalIndex, "name")}
                            data-incomplete={Boolean(item.nameCheck)}
                          >
                            <Field
                              className={styles.fieldLabel}
                              label={locale.employeeOnDuty}
                              error={Boolean(item.nameCheck)}
                              message={employeeNameMessage(item)}
                            >
                              <TextField
                                error={item.nameCheck}
                                placeholder={locale.enterEmployeeOnDuty}
                                value={item.name}
                                validations={[Validation.required({ noMessage: true })]}
                                onChange={(_, { value }) => {
                                  onChangeName(value, originalIndex);
                                }}
                              />
                            </Field>
                          </div>
                          <div
                            className={styles.attendanceField}
                            id={employeeAnchorId(originalIndex, "agency")}
                            data-incomplete={Boolean(item.agencyCheck)}
                          >
                            <Field
                              className={styles.fieldLabel}
                              label={locale.agency}
                              error={Boolean(item.agencyCheck)}
                              message={item.agencyCheck ? locale.pleaseSelectAgency : ""}
                            >
                              <Dropdown
                                error={item.agencyCheck}
                                placeholder={locale.selectAgency}
                                value={
                                  !item.agency || item.agency === "Employee" ? "none" : item.agency
                                }
                                onChange={(value) => {
                                  onChangeAgency(value, originalIndex);
                                  if (originalIndex === 0) {
                                    onChangeLabel(
                                      prettifyEmployeePosition(EmployeePosition.CASHIER),
                                      originalIndex,
                                    );
                                  }
                                }}
                                options={[
                                  { label: "Basic", value: "Basic" },
                                  { label: "Citiworks", value: "Citiworks" },
                                  { label: "Direct Employee", value: "Direct Employee" },
                                  { label: "Operator", value: "Operator" },
                                  { label: "Others", value: "Others" },
                                ]}
                              />
                            </Field>
                          </div>
                          <div
                            className={styles.attendanceField}
                            id={employeeAnchorId(originalIndex, "label")}
                            data-incomplete={Boolean(item.labelCheck)}
                          >
                            <Field
                              className={styles.fieldLabel}
                              label={locale.employeePosition}
                              error={Boolean(item.labelCheck)}
                              message={item.labelCheck ? locale.pleaseSelectEmployeePosition : ""}
                            >
                              <Dropdown
                                error={item.labelCheck}
                                placeholder={locale.selectPosition}
                                onChange={(value) => {
                                  onChangeLabel(value, originalIndex);
                                }}
                                value={item.label || "none"}
                                options={[
                                  {
                                    label: prettifyEmployeePosition(EmployeePosition.STATION_HEAD),
                                    value: prettifyEmployeePosition(EmployeePosition.STATION_HEAD),
                                  },
                                  {
                                    label: prettifyEmployeePosition(EmployeePosition.STATION_CREW),
                                    value: prettifyEmployeePosition(EmployeePosition.STATION_CREW),
                                  },
                                  {
                                    label: prettifyEmployeePosition(EmployeePosition.CASHIER),
                                    value: prettifyEmployeePosition(EmployeePosition.CASHIER),
                                  },
                                  {
                                    label: prettifyEmployeePosition(
                                      EmployeePosition.SECURITY_GUARD,
                                    ),
                                    value: prettifyEmployeePosition(
                                      EmployeePosition.SECURITY_GUARD,
                                    ),
                                  },
                                  {
                                    label: prettifyEmployeePosition(
                                      EmployeePosition.SERVICE_ADVISOR,
                                    ),
                                    value: prettifyEmployeePosition(
                                      EmployeePosition.SERVICE_ADVISOR,
                                    ),
                                  },
                                  {
                                    label: prettifyEmployeePosition(EmployeePosition.TECHNICIAN),
                                    value: prettifyEmployeePosition(EmployeePosition.TECHNICIAN),
                                  },
                                ]}
                              />
                            </Field>
                          </div>
                          <div
                            className={styles.attendanceField}
                            id={employeeAnchorId(originalIndex, "timeInAt")}
                            data-incomplete={Boolean(item.timeInAtCheck)}
                          >
                            <Field
                              className={styles.fieldLabel}
                              label={locale.dateAndTimeIn}
                              error={Boolean(item.timeInAtCheck)}
                              message={item.timeInAtCheck ? locale.pleaseSelectDateAndTimeIn : ""}
                            >
                              <DateTimePickerPopup
                                name={`timeInAt_${originalIndex}`}
                                value={item.timeInAt}
                                placeholder="MM/DD/YYYY  --:--"
                                format="MM/DD/YYYY hh:mm A"
                                error={item.timeInAtCheck}
                                onChange={(_, { value }) => onChangeTimeIn(value, originalIndex)}
                              />
                            </Field>
                          </div>
                          <div className={styles.attendanceRemove}>
                            {displayIndex > 0 && (
                              <span
                                onClick={() => onRemove(originalIndex)}
                                className={styles.remove}
                              >
                                <Image src={TrashcanIcon} />
                              </span>
                            )}
                          </div>
                        </div>
                        <div className={styles.attendanceRow}>
                          <div
                            className={styles.attendanceField}
                            id={employeeAnchorId(originalIndex, "timeOutAt")}
                            data-incomplete={Boolean(item.timeOutAtCheck)}
                          >
                            <Field
                              className={styles.fieldLabel}
                              label={locale.dateAndTimeOut}
                              error={Boolean(item.timeOutAtCheck)}
                              message={employeeTimeOutMessage(item)}
                            >
                              <DateTimePickerPopup
                                name={`timeOutAt_${originalIndex}`}
                                value={item.timeOutAt}
                                placeholder="MM/DD/YYYY  --:--"
                                format="MM/DD/YYYY hh:mm A"
                                error={item.timeOutAtCheck}
                                minDateTime={
                                  item.timeInAt
                                    ? new Date(new Date(item.timeInAt).getTime() + 60 * 1000)
                                    : undefined
                                }
                                onChange={(_, { value }) => onChangeTimeOut(value, originalIndex)}
                              />
                            </Field>
                          </div>
                          <div className={styles.straightDutyWrapper}>
                            <Checkbox
                              value={item.isStraightDuty || false}
                              onChange={(_, { value }) =>
                                onChangeStraightDuty(value, originalIndex)
                              }
                            />
                            <Text>{locale.markAsStraightDuty}</Text>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <>
                  {employees
                    .filter((item) => item.name?.toLowerCase() !== "stocq variance")
                    .map((item, i) => (
                      <div key={i} className={styles.attendanceViewCard}>
                        <div className={grid.row}>
                          <div className={grid.column}>
                            <Text className={styles.classLabel}>{locale.employeeOnDuty}</Text>
                            <Text className={styles.content}>{item.name || "-"}</Text>
                          </div>
                          <div className={grid.column}>
                            <Text className={styles.classLabel}>{locale.agency}</Text>
                            <Text className={styles.content}>
                              {item.agency === "Employee" ? "-" : item.agency || "-"}
                            </Text>
                          </div>
                          <div className={grid.column}>
                            <Text className={styles.classLabel}>{locale.employeePosition}</Text>
                            <Text className={styles.content}>{item.label || "-"}</Text>
                          </div>
                          <div className={grid.column}>
                            <Text className={styles.classLabel}>{locale.dateAndTimeIn}</Text>
                            <Text className={styles.content}>
                              {item.timeInAt ? dateTimeFormatSlash(item.timeInAt) : "-"}
                            </Text>
                          </div>
                        </div>
                        <div className={grid.row}>
                          <div className={grid.column}>
                            <div className={styles.dateOutHeader}>
                              <Text className={styles.classLabel}>{locale.dateAndTimeOut}</Text>
                            </div>
                            <Text className={styles.content}>
                              {item.timeOutAt ? dateTimeFormatSlash(item.timeOutAt) : "-"}
                            </Text>
                          </div>
                          <div className={grid.column} style={{ paddingTop: "2.5em" }}>
                            {item.isStraightDuty && <Pill grass>{locale.straightDuty}</Pill>}
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              )}
            </div>
            {pageMode === FormMode.Edit && (
              <Button
                exportButton
                onClick={addRow}
                startIcon={<AddIcon />}
                disabled={employees.find(
                  (i) =>
                    i.nameCheck ||
                    i.agencyCheck ||
                    i.labelCheck ||
                    i.timeInAtCheck ||
                    i.timeOutAtCheck,
                )}
              >
                {locale.addEmployee}
              </Button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ShiftRecordsDetailsInfoModule;
